import { Container } from '@angular/compiler/src/i18n/i18n_ast';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ContainersService } from '@services/containers/containers.service';
import { DialogData } from '../opendialog-delete-container/opendialog-delete-container.component';

@Component({
  selector: 'app-opendialog-infos-container',
  templateUrl: './opendialog-infos-container.component.html',
  styleUrls: ['./opendialog-infos-container.component.scss']
})
export class OpendialogInfosContainerComponent implements OnInit {
  infosContainer: Container;

  constructor(
    public dialogRef: MatDialogRef<OpendialogInfosContainerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private containersService: ContainersService
  ) { }

  ngOnInit(): void {
    this.getInfosContainer();
  }

  private getInfosContainer(): void {
    this.containersService.getSingleContainer(this.data.idContainer).subscribe(res => {
      this.infosContainer = res;
      console.table(res);
    });
  }

}
